import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { Response } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { LoginModel, LoginResponse, CurrentUser } from '../../models/inModels/loginModel';
import { RegisterModel } from '../../models/inModels/registerModel';
import { environment } from '../../../environments/environment';
import { LoggingService } from '../logging/logging.service';
import { Claim } from '../../models/outModels/Claim';
import { ChangePasswordModel, ForgotPasswordModel, ResetPasswordModel, ChangePasswordUserModel } from "../../models/inModels/ChangePasswordModel";


@Injectable()
export class AuthenticationService {
	accesToken: string;
	apiUrl = environment.apiUrl;
	header = new HttpHeaders();
	headerAuth = new HttpHeaders();
	private currentUser;
	private userClaims: Claim[];
	constructor(
		private http: HttpClient,
		private router: Router,
		private logging: LoggingService) {
		// set token if saved in local storage
		this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
		this.userClaims = JSON.parse(localStorage.getItem('userClaims'));
		this.accesToken = this.currentUser && this.currentUser.token;
		this.headerAuth = new HttpHeaders().set('Authorization', `Bearer ${this.accesToken}`);
		this.header = new HttpHeaders().set('Authorization', `Bearer ${this.accesToken}`);
		this.header = this.header.set('Content-Type', 'application/json');
	}

	private headerUrlEncodedForm = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
	private headerJson = new HttpHeaders().set('Content-Type', 'application/json');

	login(model: LoginModel): Observable<boolean> {
		let body = `username=${model.username}&password=${model.password}&grant_type=password`;
		return this.http
			.post(`${this.apiUrl}/Token`, body, { headers: this.headerUrlEncodedForm })
			.map((response: LoginResponse) => {
				const data = response;
				if (data) {
					// set token property
					this.accesToken = data.access_token;
					this.header = new HttpHeaders().set('Authorization', `Bearer ${this.accesToken}`);
					this.header = this.header.set('Content-Type', 'application/json');

					// store user name and  token in local storage to keep user logged in between page refreshes
					this.setUser(response);

					// get claims
					this.getClaims();

					// get subscriptions
					//this.getSubscriptions();

					// return true to indicate successful login
					return true;
				} else {
					// return false to indicate failed login
					return false;
				}
			});
	}

	private getClaims(): Promise<any> {
		return this.http.get(`${this.apiUrl}/api/account/claims`, { headers: this.header })
			.toPromise()
			.then(response => {
				localStorage.setItem('userClaims', JSON.stringify(response));
				return response;
			})
			.catch(error => this.logging.handleError(error));
	}

	private getSubscriptions(): Promise<any> {
		return this.http.get(`${this.apiUrl}/api/licensekeys/valid`, { headers: this.header })
			.toPromise()
			.then(response => {
				//console.log(response);
				localStorage.setItem('userSubscription', JSON.stringify(response));
				return response;
			})
			.catch(error => this.logging.handleError(error));
	}

	register(model: RegisterModel): Promise<any> {
		return this.http
			.post(`${this.apiUrl}/api/account/register`, JSON.stringify(model), { headers: this.headerJson })
			.toPromise()
			.then(response => response as any)
			.catch(error => this.logging.handleError(error));
	}

	userExist(userName: string): Promise<boolean> {
		return this.http
			.post(`${this.apiUrl}/api/account/exists`, `{"UserName": "${userName}"}`, { headers: this.headerJson })
			.toPromise()
			.then(response => response as boolean)
			.catch(error => this.logging.handleError(error));
	}

	changePassword(model: ChangePasswordModel): Promise<any> {
		return this.http
			.post(`${this.apiUrl}/api/account/changepassword`, JSON.stringify(model), { headers: this.header })
			.toPromise()
			.then(response => {
				//console.log(response);
				return response as any;
			})
			.catch(error => this.logging.handleError(error));
	}

	changeUserPassword(model: ChangePasswordUserModel): Promise<any> {
		return this.http
			.post(`${this.apiUrl}/api/account/changepassword/user`, JSON.stringify(model), { headers: this.header })
			.toPromise()
			.then(response => {
				//console.log(response);
				return response as any;
			})
			.catch(error => this.logging.handleError(error));
	}

	sendLogin(model: ChangePasswordUserModel): Promise<any> {
		return this.http
			.post(`${this.apiUrl}/api/account/send-login`, JSON.stringify(model), { headers: this.header })
			.toPromise()
			.then(response => {
				//console.log(response);
				return response as any;
			})
			.catch(error => this.logging.handleError(error));
	}

	forgotPassword(model: ForgotPasswordModel): Promise<any> {
		return this.http
			.post(`${this.apiUrl}/api/account/forgotpassword`, JSON.stringify(model), { headers: this.headerJson })
			.toPromise()
			.then(response => {
				//console.log(response);
				return response as any;
			})
			.catch(error => this.logging.handleError(error));
	}

	resetPassword(model: ResetPasswordModel): Promise<any> {
		return this.http
			.post(`${this.apiUrl}/api/account/resetpassword`, JSON.stringify(model), { headers: this.headerJson })
			.toPromise()
			.then(response => {
				//console.log(response);
				return response as any;
			})
			.catch(error => this.logging.handleError(error));
	}

	resetPasswordOtp(model: ResetPasswordModel): Promise<any> {
		return this.http
			.post(`${this.apiUrl}/api/account/resetpassword/otp`, JSON.stringify(model), { headers: this.headerJson })
			.toPromise()
			.then(response => {
				return response as any;
			})
			.catch(error => this.logging.handleError(error));
	}

	logout(): void {
		// clear token remove user from local storage to log user out
		this.accesToken = null;
		localStorage.removeItem('currentUser');
		this.currentUser = null;
		localStorage.removeItem('userClaims');
		this.userClaims = null;
		localStorage.clear();
	}

	/**
	 * Check whether the current user has the claim for the group and type
	 * @param claimGroup
	 * @param claimType
	 */
	userHasClaim(claimGroup, claimType): boolean {
		const userClaims = this.getUserClaims();
		// console.log(userClaims);
		for (let i = 0; i < userClaims.length; i++) {
			if (userClaims[i].ClaimGroup === claimGroup && userClaims[i].ClaimType === claimType) {
				return true;
			}
		}
		return false;
	}

	/**
	 * Returns all the current users claims
	 */
	getUserClaims(): Claim[] {
		if (this.userClaims == null) {
			this.userClaims = JSON.parse(localStorage.getItem('userClaims'));
		}
		return this.userClaims;
	}

	/**
	 * Return the current user
	 */
	getUser(): CurrentUser {
		if (this.currentUser == null) {
			this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
		}
		return this.currentUser;
	}

	private setUser(response: LoginResponse): void {
		this.currentUser = new CurrentUser(response);
		//Persist to storage
		localStorage.setItem('currentUser', JSON.stringify(
			this.currentUser
		));
	}

	isAuthenticated(): boolean {
		let user = this.getUser();
		if (user) {
			let now = new Date();
			let expires = new Date(user.expires);
			if (user.token && expires > now) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	}

	convertToUtc(date: Date) {
		if (!(date instanceof Date)) {
			return null;
		}
		
		return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/authentication/authentication.service.ts